import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15 6h6v6h-6z",
      style: {"fill":"none","stroke-width":"2.07px"},
      transform: "rotate(-45 15.94 10.975)"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.243 11.243V19",
      style: {"stroke-width":"2.07px"},
      transform: "translate(-1.243 1.121)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "7.5",
      cy: "9.5",
      r: "2.5",
      style: {"fill":"none","stroke-width":"2.07px"},
      transform: "translate(-1.243 1.121)"
    }, null, -1)
  ]))]))
}
export default { render: render }